import {
  Card,
  CardBody,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@apollo/orbit';
import React from 'react';

import { InsightsLineChartTooltip } from 'src/app/graph/insights/InsightsLineChartTooltip';
import { SeriesControls } from 'src/components/charts/helpers/SeriesControls';
import { LineChart } from 'src/components/charts/LineChart';
import { DateRangeBadge } from 'src/components/dateRangeBadge/DateRangeBadge';
import { Resolution } from 'src/lib/graphqlTypes/types';

import { useServiceReportLineCharts } from './ServiceReportLineCharts';
import { SubscriptionEventInfoIcon } from './SubscriptionEventInfoIcon';

interface Props {
  eventsLineChartStackInfo: ReturnType<
    typeof useServiceReportLineCharts
  >['eventsLineChartStackInfo'];
  resolution: Resolution;
}

export function SubscriptionNotificationRateOverTime({
  eventsLineChartStackInfo,
  resolution,
}: Props) {
  return (
    <Card variant="unstyled">
      <CardHeader className="pl-3">
        <CardTitle>
          <span>Subscription notification rate</span>
          <SubscriptionEventInfoIcon />
          <DateRangeBadge />
        </CardTitle>
        <CardDescription>The number of updates per minute.</CardDescription>
      </CardHeader>
      <CardBody>
        <LineChart
          {...eventsLineChartStackInfo}
          stacked
          className="h-36"
          strokeWidth={1}
          resolution={resolution}
          data-testid="events-line-chart"
          tooltipLabelAs={
            <InsightsLineChartTooltip title="Notification rate" />
          }
          hideCursorArrow
        />
        <SeriesControls
          className="w-full px-4 pt-6 text-center"
          hideWhenSingleStack
          {...eventsLineChartStackInfo}
        />
      </CardBody>
    </Card>
  );
}
